enum EMedia {
  IMAGE = "image",
  VIDEO = "video",
}


export { EMedia };
